<template>
    <BulmaAccordionItem class="mb-spc20">
        <h4 slot="title" v-if="accordion.title" class="text-xl font-bold leading-6 tracking-spc1 cursor-pointer">
            {{accordion.title}}
        </h4>
        <p slot="content" v-if="accordion.content" class="opacity-50 leading-6">
            {{accordion.content}}
        </p>
    </BulmaAccordionItem>
</template>

<script>
    import { BulmaAccordionItem } from 'vue-bulma-accordion'

    export default {
        name: "HiwAccordionItems",
        props: ['accordion'],
        components: {
            BulmaAccordionItem
        }
    }
</script>

<style scoped>

</style>